import { IconRegisterOptions } from '../../models/icon-register';

export const ICON_REGISTER_LIST: IconRegisterOptions[] = [
  { iconName: 'otp-flag-bg', url: 'media/otp-flag-bg.svg' },
  { iconName: 'otp-flag-en', url: 'media/otp-flag-en.svg' },
  { iconName: 'otp-alarm-bell', url: 'media/otp-alarm-bell.svg' },
  { iconName: 'down-arrow', url: 'media/down-arrow.svg' },
  { iconName: 'user', url: 'media/user.svg' },
  { iconName: 'bulb', url: 'media/bulb.svg' },
  { iconName: 'otp-filter', url: 'media/otp-filter.svg' },
  { iconName: 'otp-edit', url: 'media/otp-edit.svg' },
  { iconName: 'otp-arrow-right', url: 'media/otp-arrow-right.svg' },
  { iconName: 'otp-arrow-left', url: 'media/otp-arrow-left.svg' },
  { iconName: 'otp-plus', url: 'media/otp-plus.svg' },
  { iconName: 'otp-close', url: 'media/otp-close.svg' },
  { iconName: 'dsk-logo', url: 'media/dsk-logo.svg' },
  { iconName: 'dskhome-logo', url: 'media/dskhome-logo.svg' },
  { iconName: 'otp-line-11', url: 'media/otp-line-11.svg' },
  { iconName: 'otp-premium', url: 'media/otp-premium.svg' },
  { iconName: 'otp-key', url: 'media/otp-key.svg' },
  { iconName: 'otp-arrow-down', url: 'media/otp-arrow-down.svg' },
  { iconName: 'otp-arrow-up', url: 'media/otp-arrow-up.svg' },
  { iconName: 'otp-paragraph', url: 'media/otp-paragraph.svg' },
  { iconName: 'otp-properties', url: 'media/otp-properties.svg' },
  { iconName: 'cookie-consent-icon', url: 'media/cookie-consent-icon.svg' },
  { iconName: 'otp-chat', url: 'media/otp-chat.svg' },
  { iconName: 'otp-line-11', url: 'media/otp-line-11.svg' },
  { iconName: 'otp-view-off', url: 'media/otp-view-off.svg' },
  { iconName: 'otp-view', url: 'media/otp-view.svg' },
  { iconName: 'otp-info', url: 'media/otp-info.svg' },
  { iconName: 'otp-bubble-indicator', url: 'media/otp-bubble-indicator.svg' },
  { iconName: 'otp-search-house', url: 'media/otp-search-house.svg' },
  { iconName: 'otp-maps-search', url: 'media/otp-maps-search.svg' },
  { iconName: 'otp-money-document', url: 'media/otp-money-document.svg' },
  { iconName: 'otp-money-saving', url: 'media/otp-money-saving.svg' },
  { iconName: 'otp-home', url: 'media/otp-home.svg' },
  { iconName: 'otp-home-star', url: 'media/otp-home-star.svg' },
  { iconName: 'otp-home-own', url: 'media/otp-home-own.svg' },
  { iconName: 'otp-gear', url: 'media/otp-gear.svg' },
  { iconName: 'otp-question-circle', url: 'media/otp-question-circle.svg' },
  { iconName: 'otp-question-circle-96x96', url: 'media/otp-question-circle-96x96.svg' },
  { iconName: 'otp-sell', url: 'media/otp-sell.svg' },
  { iconName: 'otp-shopping-cart', url: 'media/otp-shopping-cart.svg' },
  { iconName: 'facebook', url: 'media/facebook.svg' },
  { iconName: 'linkedin', url: 'media/linkedin.svg' },
  { iconName: 'youtube', url: 'media/youtube.svg' },
  { iconName: 'dsk-logo-footer', url: 'media/dsk-logo-footer.svg' },
  { iconName: 'otp-sort-column', url: 'media/otp-sort-column.svg' },
  { iconName: 'otp-sort-column-up', url: 'media/otp-sort-column-up.svg' },
  { iconName: 'otp-unidentified-browser', url: 'media/otp-unidentified-browser.svg' },
  { iconName: 'otp-drawer-toggle', url: 'media/otp-drawer-toggle.svg' },
  { iconName: 'otp-paginator-separator', url: 'media/otp-paginator-separator.svg' },
  { iconName: 'otp-red-bubble-indicator', url: 'media/otp-red-bubble-indicator.svg' },
  { iconName: 'otp-calendar', url: 'media/otp-calendar.svg' },
  { iconName: 'otp-calendar-add', url: 'media/otp-calendar-add.svg' },
  { iconName: 'otp-calendar-money', url: 'media/otp-calendar-money.svg' },
  { iconName: 'otp-calendar-clock', url: 'media/otp-calendar-clock.svg' },
  { iconName: 'otp-profile', url: 'media/otp-profile.svg' },
  { iconName: 'otp-profile-admin', url: 'media/otp-profile-admin.svg' },
  { iconName: 'otp-profile-role-authority', url: 'media/otp-profile-role-authority.svg' },
  { iconName: 'otp-profile-headset', url: 'media/otp-profile-headset.svg' },
  { iconName: 'otp-credit-card', url: 'media/otp-credit-card.svg' },
  { iconName: 'otp-business', url: 'media/otp-business.svg' },
  { iconName: 'otp-businessman', url: 'media/otp-businessman.svg' },
  { iconName: 'otp-alternatives', url: 'media/otp-alternatives.svg' },
  { iconName: 'otp-map', url: 'media/otp-map.svg' },
  { iconName: 'otp-plus-in-circle', url: 'media/otp-plus-in-circle.svg' },
  { iconName: 'otp-trash', url: 'media/otp-trash.svg' },
  { iconName: 'otp-search', url: 'media/otp-search.svg' },
  { iconName: 'otp-check-no-results', url: 'media/otp-check-no-results.svg' },
  { iconName: 'otp-area', url: 'media/otp-area.svg' },
  { iconName: 'otp-bedroom', url: 'media/otp-bedroom.svg' },
  { iconName: 'otp-floor', url: 'media/otp-floor.svg' },
  { iconName: 'dsk-logo-symbol', url: 'media/dsk-logo-symbol.svg' },
  { iconName: 'otp-cap-square-completed-to-active', url: 'media/otp-cap-square-completed-to-active.svg' },
  { iconName: 'otp-cap-square-completed-to-completed', url: 'media/otp-cap-square-completed-to-completed.svg' },
  { iconName: 'otp-cap-square-active-to-disabled', url: 'media/otp-cap-square-active-to-disabled.svg' },
  { iconName: 'otp-cap-square-disabled-to-disabled', url: 'media/otp-cap-square-disabled-to-disabled.svg' },
  { iconName: 'otp-rectangle-active-left', url: 'media/otp-rectangle-active-left.svg' },
  { iconName: 'otp-rectangle-active-right', url: 'media/otp-rectangle-active-right.svg' },
  { iconName: 'otp-rectangle-completed-left', url: 'media/otp-rectangle-completed-left.svg' },
  { iconName: 'otp-rectangle-completed-right', url: 'media/otp-rectangle-completed-right.svg' },
  { iconName: 'otp-rectangle-disabled-left', url: 'media/otp-rectangle-disabled-left.svg' },
  { iconName: 'otp-rectangle-disabled-right', url: 'media/otp-rectangle-disabled-right.svg' },
  { iconName: 'otp-rectangle-mobile-active-left', url: 'media/otp-rectangle-mobile-active-left.svg' },
  { iconName: 'otp-rectangle-mobile-active-right', url: 'media/otp-rectangle-mobile-active-right.svg' },
  { iconName: 'otp-rectangle-mobile-completed-left', url: 'media/otp-rectangle-mobile-completed-left.svg' },
  { iconName: 'otp-rectangle-mobile-completed-right', url: 'media/otp-rectangle-mobile-completed-right.svg' },
  { iconName: 'otp-rectangle-mobile-disabled-left', url: 'media/otp-rectangle-mobile-disabled-left.svg' },
  { iconName: 'otp-rectangle-mobile-disabled-right', url: 'media/otp-rectangle-mobile-disabled-right.svg' },
  { iconName: 'otp-arrow-left-right', url: 'media/otp-arrow-left-right.svg' },
  { iconName: 'otp-marker', url: 'media/otp-marker.svg' },
  { iconName: 'otp-slider-indicator', url: 'media/otp-slider-indicator.svg' },
  { iconName: 'otp-minus', url: 'media/otp-minus.svg' },
  { iconName: 'otp-minus-in-circle', url: 'media/otp-minus-in-circle.svg' },
  { iconName: 'otp-telephone', url: 'media/otp-telephone.svg' },
  { iconName: 'otp-camera', url: 'media/otp-camera.svg' },
  { iconName: 'otp-check-in-circle', url: 'media/otp-check-in-circle.svg' },
  { iconName: 'otp-check-in-circle-96x96', url: 'media/otp-check-in-circle-96x96.svg' },
  { iconName: 'otp-family-child', url: 'media/otp-family-child.svg' },
  { iconName: 'otp-loan', url: 'media/otp-loan.svg' },
  { iconName: 'otp-time-clock', url: 'media/otp-time-clock.svg' },
  { iconName: 'otp-receipt-slip', url: 'media/otp-receipt-slip.svg' },
  { iconName: 'otp-error-96x96', url: 'media/otp-error-96x96.svg' },
  { iconName: 'otp-error-circle-96x96', url: 'media/otp-error-circle-96x96.svg' },
  { iconName: 'otp-handshake', url: 'media/otp-handshake.svg' },
  { iconName: 'otp-success-96x96', url: 'media/otp-success-96x96.svg' },
  { iconName: 'otp-alert-triangle-96x96', url: 'media/otp-alert-triangle-96x96.svg' },
  { iconName: 'otp-salary-euro', url: 'media/otp-salary-euro.svg' },
  { iconName: 'otp-sort-asc', url: 'media/otp-sort-asc.svg' },
  { iconName: 'otp-download', url: 'media/otp-download.svg' },
  { iconName: 'otp-award-ribbon-star', url: 'media/otp-award-ribbon-star.svg' },
  { iconName: 'otp-bulb', url: 'media/otp-bulb.svg' },
  { iconName: 'otp-rotate-forward', url: 'media/otp-rotate-forward.svg' },
  { iconName: 'otp-check', url: 'media/otp-check.svg' },
  { iconName: 'otp-full-screen', url: 'media/otp-full-screen.svg' },
  { iconName: 'otp-bulb-filled', url: 'media/otp-bulb-filled.svg' },
  { iconName: 'otp-print', url: 'media/otp-print.svg' },
  { iconName: 'otp-risk-profile-stable', url: 'media/otp-risk-profile-stable.svg' },
  { iconName: 'otp-add-favorit', url: 'media/otp-add-favorit.svg' },
  { iconName: 'otp-chair', url: 'media/otp-chair.svg' },
  { iconName: 'otp-plant-nurturing', url: 'media/otp-plant-nurturing.svg' },
  { iconName: 'otp-shield', url: 'media/otp-shield.svg' },
  { iconName: 'ph-thermometer-hot', url: 'media/ph-thermometer-hot.svg' },
  { iconName: 'streamline-location-compass-1', url: 'media/streamline-location-compass-1.svg' },
  { iconName: 'otp-demo-img', url: 'media/otp-demo-img.svg' },
  { iconName: 'otp-fail', url: 'media/otp-fail.svg' },
  { iconName: 'otp-money-large', url: 'media/otp-money-large.svg' },
  { iconName: 'otp-money-upload', url: 'media/otp-money-upload.svg' },
  { iconName: 'otp-coins-bill', url: 'media/otp-coins-bill.svg' },
  { iconName: 'otp-check-in-circle-big', url: 'media/otp-check-in-circle-big.svg' },
  { iconName: 'otp-identification-big', url: 'media/otp-identification-big.svg' },
  { iconName: 'otp-document', url: 'media/otp-document.svg' },
  { iconName: 'otp-finishline-96x96', url: 'media/otp-finishline-96x96.svg' },
  { iconName: 'otp-multiple-neutral', url: 'media/otp-multiple-neutral.svg' },
  { iconName: 'otp-multiple-neutral-32x32', url: 'media/otp-multiple-neutral-32x32.svg' },
  { iconName: 'otp-heart', url: 'media/otp-heart.svg' },
  { iconName: 'otp-maps-pin', url: 'media/otp-maps-pin.svg' },
  { iconName: 'otp-phone-actions-call', url: 'media/otp-phone-actions-call.svg' },
  { iconName: 'otp-copy', url: 'media/otp-copy.svg' },
  { iconName: 'otp-businessman-96x96', url: 'media/otp-businessman-96x96.svg' },
  { iconName: 'otp-delete-16x16', url: 'media/otp-delete-16x16.svg' },
  { iconName: 'cuida-pie-chart', url: 'media/cuida-pie-chart.svg' },
  { iconName: 'uil-money-stack', url: 'media/uil-money-stack.svg' },
  { iconName: 'uil-money-banknote', url: 'media/uil-money-banknote.svg' },
  { iconName: 'uil-shield', url: 'media/uil-shield.svg' },
  { iconName: 'solar-shield-check-linear', url: 'media/solar-shield-check-linear.svg' },
  { iconName: 'otp-bus', url: 'media/otp-bus.svg' },
  { iconName: 'otp-pin-72x72', url: 'media/otp-pin-72x72.svg' },
  { iconName: 'otp-pin-location', url: 'media/otp-pin-location.svg' },
  { iconName: 'otp-study-owl', url: 'media/otp-study-owl.svg' },
  { iconName: 'otp-analytics-72x72', url: 'media/otp-analytics-72x72.svg' },
  { iconName: 'otp-calendar-plus-one', url: 'media/otp-calendar-plus-one.svg' },
  { iconName: 'otp-chart', url: 'media/otp-chart.svg' },
  { iconName: 'otp-discount-circle-72x72', url: 'media/otp-discount-circle-72x72.svg' },
  { iconName: 'otp-lock', url: 'media/otp-lock.svg' },
  { iconName: 'otp-money-in-hand-72x72', url: 'media/otp-money-in-hand-72x72.svg' },
  { iconName: 'otp-table-check', url: 'media/otp-table-check.svg' },
  { iconName: 'otp-time-clock-circle', url: 'media/otp-time-clock-circle.svg' },
  { iconName: 'otp-delayed', url: 'media/otp-delayed.svg' },
  { iconName: 'otp-enlarge', url: 'media/otp-enlarge.svg' },
  { iconName: 'otp-alert-triangle-24x24', url: 'media/otp-alert-triangle-24x24.svg' },
  { iconName: 'otp-analytics-32x32', url: 'media/otp-analytics-32x32.svg' },
  { iconName: 'otp-calculator-docs-32x32', url: 'media/otp-calculator-docs-32x32.svg' },
  { iconName: 'otp-notebook-32x32', url: 'media/otp-notebook-32x32.svg' },
  { iconName: 'otp-proposal-id-card-96x96', url: 'media/otp-proposal-id-card-96x96.svg' },
  { iconName: 'otp-proposal-mobile-96x96', url: 'media/otp-proposal-mobile-96x96.svg' },
  { iconName: 'otp-24-hours-96x96', url: 'media/otp-24-hours-96x96.svg' },
  { iconName: 'otp-money', url: 'media/otp-money.svg' },
  { iconName: 'otp-data-check-72x72', url: 'media/otp-data-check-72x72.svg' },
  { iconName: 'otp-proposal-fail-people-96x96', url: 'media/otp-proposal-fail-people-96x96.svg' },
  { iconName: 'otp-identification-failed-96x96', url: 'media/otp-identification-failed-96x96.svg' },
  { iconName: 'otp-arrived-letter-96x96', url: 'media/otp-arrived-letter-96x96.svg' },
  { iconName: 'otp-close-red', url: 'media/otp-close-red.svg' },
  { iconName: 'otp-delete-24x24', url: 'media/otp-delete-24x24.svg' },
  { iconName: 'otp-single-neutral-24x24', url: 'media/otp-single-neutral-24x24.svg' },
  { iconName: 'otp-single-success-24x24', url: 'media/otp-single-success-24x24.svg' },
  { iconName: 'otp-error-24x24', url: 'media/otp-error-24x24.svg' },
  { iconName: 'otp-close-24x24', url: 'media/otp-close-24x24.svg' },
  { iconName: 'otp-archive-24x24', url: 'media/otp-archive-24x24.svg' },
  { iconName: 'otp-resend-mail', url: 'media/otp-resend-mail.svg' },
  { iconName: 'otp-session-expired', url: 'media/session-expired.svg' },
  { iconName: 'otp-analytics-48x48', url: 'media/otp-analytics-48x48.svg' },
  { iconName: 'otp-price-range-32x32', url: 'media/otp-price-range-32x32.svg' },
  { iconName: 'otp-personal-loan-48x48', url: 'media/otp-personal-loan-48x48.svg' },
  { iconName: 'otp-money-document-with-background-32x32', url: 'media/otp-money-document-with-background-32x32.svg' },
  { iconName: 'otp-money-with-background-32x32', url: 'media/otp-money-with-background-32x32.svg' },
  { iconName: 'otp-repeating-with-interest-32x32', url: 'media/otp-repeating-with-interest-32x32.svg' },
  { iconName: 'otp-percentage-in-circle-32x32', url: 'media/otp-percentage-in-circle-32x32.svg' },
  { iconName: 'otp-analysis-graph-interest-48x48', url: 'media/otp-analysis-graph-interest-48x48.svg' },
  { iconName: 'otp-scatter-plot-32x32', url: 'media/otp-scatter-plot-32x32.svg' },
  { iconName: 'otp-average-calculator-32x32', url: 'media/otp-average-calculator-32x32.svg' },
  { iconName: 'otp-house-card-32x32', url: 'media/otp-house-card-32x32.svg' },
  { iconName: 'otp-envelope-24x24', url: 'media/otp-envelope-24x24.svg' },
  { iconName: 'otp-heart-96x96', url: 'media/otp-heart-96x96.svg' },
  { iconName: 'otp-chat-bubbles', url: 'media/otp-chat-bubbles.svg' },
];
